import React from 'react'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'

import Heading from '@react/react-spectrum/Heading'
import Well from '@react/react-spectrum/Well'
import { error } from '@react/react-spectrum/Toast'

import Checkbox from '@react/react-spectrum/Checkbox'
import OverlayTrigger from '@react/react-spectrum/OverlayTrigger'
import Tooltip from '@react/react-spectrum/Tooltip'

export default function SenseiParams (props) {
    function toggleDistractorPeople () {
        const peopleDistractor = !props.params.people_distractor
        props.setParams({ ...props.params, people_distractor: peopleDistractor })
    }
    function toggleDistractorWire () {
        const wireRemoval = !props.params.wire_removal
        props.setParams({ ...props.params, wire_removal: wireRemoval })
    }

    try {
        return <div className="adobe-skycity-output-options">
            <Well>
                <Heading variant="pageTitle">{__('skycity_comp_title_output_options')}</Heading>
                <React.Fragment>
                    <Heading className="adobe-skycity-subtitle1" variant="subtitle1">Sensei Params</Heading>
                    <Well>
                        <div className="adobe-skycity-options-col">
                            <div className="adobe-skycity-distractor-option">
                                <OverlayTrigger placement="right">
                                    <Checkbox value={props.params.people_distractor}
                                        defaultChecked={props.params.people_distractor}
                                        onChange={ e => toggleDistractorPeople()}
                                        label={__('output_option_tooltip_people_distractor_label_distractor')}>
                                    </Checkbox>
                                    <Tooltip variant="info">
                                        {__('output_option_tooltip_people_distractor_label_distractor')}
                                    </Tooltip>
                                </OverlayTrigger>
                            </div>
                            <div className="adobe-skycity-distractor-option">
                                <OverlayTrigger placement="right">
                                    <Checkbox value={props.params.wire_removal}
                                        onChange={ e => toggleDistractorWire()}
                                        label={__('output_option_tooltip_wire_removal_label_distractor')}>
                                    </Checkbox>
                                    <Tooltip variant="info">
                                        {__('output_option_tooltip_wire_removal_label_distractor')}
                                    </Tooltip>
                                </OverlayTrigger>
                            </div>
                        </div>
                    </Well>
                </React.Fragment>
            </Well>
        </div>
    } catch (e) {
        console.log(e)
        error(`${__('error_msg_title')}: ${e}`, {
            timeout: 0
        })
    }
}
